module.exports = __webpack_public_path__ + "img/r-191.df8e20ae.jpg";